<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-header">
                <div class="utils__title">
                    <strong>UPSI Subscription Settings</strong>
                </div>
                <div class="utils__sub-title">
                    <span>Company: {{ companyName }}</span>
                </div>
            </div>
            <div class="card-body">
                <!-- Loading Indicator -->
                <div *ngIf="isLoading" class="text-center" style="padding: 40px;">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-3">Loading subscription settings...</p>
                </div>

                <!-- Content -->
                <div *ngIf="!isLoading">
                    <!-- Current Subscription Display -->
                    <div class="row mb-4">
                        <div class="col-lg-12">
                            <div class="alert" 
                                 [ngClass]="{'alert-success': isUPSIMain, 'alert-info': isUPSILite}">
                                <h5 class="mb-2">
                                    <i class="fa fa-info-circle mr-2"></i>
                                    Current Subscription: <strong>{{ getSubscriptionLabel(currentSubscription) }}</strong>
                                </h5>
                                <p class="mb-0">{{ getSubscriptionDescription(currentSubscription) }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Toggle Switch -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card border-primary">
                                <div class="card-body">
                                    <h5 class="card-title mb-4">
                                        <i class="fa fa-toggle-on mr-2"></i>Toggle Subscription Type
                                    </h5>
                                    
                                    <div class="row align-items-center">
                                        <div class="col-md-8">
                                            <div class="subscription-toggle-container">
                                                <div class="toggle-labels">
                                                    <span [ngClass]="{'active-label': isUPSIMain, 'inactive-label': !isUPSIMain}">
                                                        <i class="fa fa-check-circle mr-1" *ngIf="isUPSIMain"></i>
                                                        UPSI Main
                                                    </span>
                                                    <span [ngClass]="{'active-label': isUPSILite, 'inactive-label': !isUPSILite}" class="ml-5">
                                                        <i class="fa fa-check-circle mr-1" *ngIf="isUPSILite"></i>
                                                        UPSI Lite
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 text-right">
                                            <button 
                                                class="btn btn-lg"
                                                [ngClass]="{'btn-success': isUPSIMain, 'btn-info': isUPSILite}"
                                                (click)="toggleSubscription()"
                                                [disabled]="isSaving">
                                                <i class="fa fa-exchange mr-2" *ngIf="!isSaving"></i>
                                                <i class="fa fa-spinner fa-spin mr-2" *ngIf="isSaving"></i>
                                                {{ isSaving ? 'Switching...' : 'Toggle Subscription' }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Subscription Comparison -->
                    <div class="row mt-4">
                        <div class="col-lg-6">
                            <div class="card" [ngClass]="{'border-success': isUPSIMain}">
                                <div class="card-body">
                                    <h5 class="card-title">
                                        <i class="fa fa-star text-warning mr-2"></i>
                                        UPSI Main
                                        <span class="badge badge-success ml-2" *ngIf="isUPSIMain">Current</span>
                                    </h5>
                                    <p class="text-muted mb-3">Full-featured UPSI management</p>
                                    <ul class="feature-list">
                                        <li><i class="fa fa-check text-success mr-2"></i>UPSI Details Management</li>
                                        <li><i class="fa fa-check text-success mr-2"></i>Bulk Data Upload</li>
                                        <li><i class="fa fa-check text-success mr-2"></i>Advanced Analytics</li>
                                        <li><i class="fa fa-check text-success mr-2"></i>Email Log Tracking</li>
                                        <li><i class="fa fa-check text-success mr-2"></i>Custom Email Templates</li>
                                        <li><i class="fa fa-check text-success mr-2"></i>Comprehensive Reporting</li>
                                        <li><i class="fa fa-check text-success mr-2"></i>Sharer & Recipient Management</li>
                                    </ul>
                                    <button 
                                        class="btn btn-success mt-3"
                                        (click)="saveSubscription('UPSI_MAIN')"
                                        [disabled]="isSaving || isUPSIMain">
                                        <i class="fa fa-check mr-2"></i>
                                        {{ isUPSIMain ? 'Active' : 'Switch to Main' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card" [ngClass]="{'border-info': isUPSILite}">
                                <div class="card-body">
                                    <h5 class="card-title">
                                        <i class="fa fa-cube text-info mr-2"></i>
                                        UPSI Lite
                                        <span class="badge badge-info ml-2" *ngIf="isUPSILite">Current</span>
                                    </h5>
                                    <p class="text-muted mb-3">Essential UPSI features</p>
                                    <ul class="feature-list">
                                        <li><i class="fa fa-check text-info mr-2"></i>UPSI Details Management</li>
                                        <li><i class="fa fa-check text-info mr-2"></i>Email Log Tracking</li>
                                        <li><i class="fa fa-check text-info mr-2"></i>Basic Reporting</li>
                                        <li><i class="fa fa-times text-muted mr-2"></i>Bulk Data Upload <span class="text-muted">(Not included)</span></li>
                                        <li><i class="fa fa-times text-muted mr-2"></i>Advanced Analytics <span class="text-muted">(Not included)</span></li>
                                        <li><i class="fa fa-times text-muted mr-2"></i>Custom Templates <span class="text-muted">(Limited)</span></li>
                                    </ul>
                                    <button 
                                        class="btn btn-info mt-3"
                                        (click)="saveSubscription('UPSI_LITE')"
                                        [disabled]="isSaving || isUPSILite">
                                        <i class="fa fa-check mr-2"></i>
                                        {{ isUPSILite ? 'Active' : 'Switch to Lite' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Information Note -->
                    <div class="row mt-4">
                        <div class="col-lg-12">
                            <div class="alert alert-warning">
                                <h6><i class="fa fa-exclamation-triangle mr-2"></i>Important Notes:</h6>
                                <ul class="mb-0">
                                    <li>Changing subscription type will affect the features available in the UPSI menu.</li>
                                    <li>The page will automatically refresh after switching subscriptions to update the menu.</li>
                                    <li>All existing data will be preserved when switching between subscription types.</li>
                                    <li>Contact your administrator if you need assistance with subscription changes.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

